import React from "react";
import classNames from "classnames";

export default class Chip extends React.PureComponent {
  render() {
    const { value, className, ...rest } = this.props;
    const chipClasses = classNames(
      "chip",
      `chip--${value}`,
      className
    );

    return (
      <img src={ `${app.assetsPath}/images/chip-${value}.png` } className={ chipClasses } {...rest} />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Chip/Chip.jsx